import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import { FunctionField } from 'admin-on-rest';
import { URL_PROJECT_STATS } from '../constants.js';
import { LinearProgress } from 'material-ui';
import fetcher from '../helpers/fetcher';

class ProjectStatsRender extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    };
  }

  componentDidMount() {
    this._loadStats();
  }

  _loadStats = () => {
    this.setState({ loading: true });
    fetcher
      .get(`${URL_PROJECT_STATS}?id=${this.props.id}`)
      .then(response => {
        this.setState({ loading: false });
        const total = get(response, 'data.data[0].all', 0);
        const remaining = get(response, 'data.data[0].notDone', 0);
        const reactivations = get(response, 'data.data[0].reactivations', 0);
        const called = total - remaining;
        this.setState({
          progress: Math.round(called / total * 100 * 100) / 100,
          called,
          total,
          reactivations,
          remaining
        });
      })
      .catch(e => {
        this.setState({ loading: false });
      });
  };

  render() {
    return (
      <span>
        {this.state.loading && <LinearProgress />}
        {~~this.state.progress}
        {'% ('}
        {this.state.called}
        {' out of '}
        {this.state.total}
        {') and '}
        {this.state.reactivations || 0}
        {' reactivations'}
      </span>
    );
    // return this.props.basket.length;
  }
}

ProjectStatsRender.propTypes = {
  id: PropTypes.number
};

const render = render => <ProjectStatsRender {...render} />;

const ProjectProgress = props => <FunctionField {...props} render={render} />;

ProjectProgress.defaultProps = {
  label: 'Progress',
  style: { textAlign: 'right' },
  headerStyle: { textAlign: 'right' }
};

export default ProjectProgress;



// WEBPACK FOOTER //
// ./src/components/ProjectProgress.js